import { ProcedureToUpdate } from '@/modules/copay/entities/interfaces/usageStatements';
import { ProcedureService } from '@/modules/copay/services/procedureService';
import { tryOrCatchMessageError } from '@/utils/tryOrCatchMessageError';
import { useCallback, useState } from 'react';

interface UseProceduresProps {
  callbackSuccess?: () => void;
}

const procedureService = new ProcedureService();

export const useProcedure = (options?: UseProceduresProps) => {
  const [loading, setLoading] = useState(false);

  const updateMany = useCallback(
    (payload: Partial<ProcedureToUpdate>[]) => {
      return tryOrCatchMessageError(
        async () => {
          await procedureService.updateMany(payload);
          options?.callbackSuccess?.();
        },
        {
          tryBefore: () => setLoading(true),
          tryAfter: () => setLoading(false),
          messageErrorDefault: 'Erro ao atualizar procedimentos.',
        },
      );
    },
    [options],
  );

  return {
    updateMany,
    loading,
  };
};
